import classNames from "classnames";
import { useSelector } from "react-redux";
import { selectReducedText, selectHideDecreasedPriceIcons } from "../store/orderingSlice";

export function StyleItemButton({ children, className, onClick, styleItem}) {
  const reduced_text = useSelector(selectReducedText);
  const hide_descreased_price_icons = useSelector(selectHideDecreasedPriceIcons);
  let price_decreased_text = ""
  if (styleItem.selection_is_reduced) {
    price_decreased_text = reduced_text;
  } else if (styleItem.selection_is_closeout) {
    price_decreased_text = "Clearance";
  } else if (styleItem.selection_is_sale) {
    price_decreased_text = "Sale";
  }
  const price_descreased_class_name = classNames({
    "style_ordering-button_icon--is-reduced": !hide_descreased_price_icons && styleItem.selection_is_reduced,
    "style_ordering-button_icon--is-closeout": !hide_descreased_price_icons && !styleItem.selection_is_reduced && styleItem.selection_is_closeout,
    "style_ordering-button_icon--is-sale": !hide_descreased_price_icons && !styleItem.selection_is_reduced && !styleItem.selection_is_closeout && styleItem.selection_is_sale
  })

  return (
    <button onClick={onClick} className={className} type="button">
      {children}
      {(styleItem.low_stock || price_decreased_text) && (
        <div className="style_ordering-button_icons">
          {price_decreased_text && (
            <span
              className={`style_ordering-button_icon ${price_descreased_class_name}`}
              title={price_decreased_text}
            ></span>
          )}
          {styleItem.low_stock && (
            <span
              className="style_ordering-button_icon style_ordering-button_icon--is-low-stock"
              title="Low Stock"
            ></span>
          )}
        </div>
      )}
    </button>
  );
}
